import { Client, UserListEvent, User } from 'irc-framework';
import { IRC_EVENT, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class UserListEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.USERLIST, (event: UserListEvent) => {
            const { channel, users, tags } = event;
            if (!this.client) return;

            const processedUsers: User[] = users.map(user => ({
                nick: user.nick,
                username: user.ident,
                hostname: user.hostname,
                modes: user.modes || [],
                account: user.account
            }));

            const tab = this.tM.getTab(tabType.CHANNEL, channel);
            if (tab) {
                this.mH.updateUserList(tab, processedUsers);
            } else {
                setTimeout(() => {
                    const retryTab = this.tM.getTab(tabType.CHANNEL, channel);
                    if (retryTab) {
                        this.mH.updateUserList(retryTab, processedUsers);
                    }
                }, 500);
            }
        });
    }
}